import type {CSSObject} from "@emotion/react";
import styled from "@emotion/styled";

export const InnerWrapper = styled.div<{styles?: CSSObject}>(({theme, styles}) => ({
  display: "flex",
  flexDirection: "column",
  gridColumn: "1/-1",
  paddingBlock: theme?.breakpoints?.md ? 30 : 40,
  ...styles,
}));

export const CardsWrapper = styled.div(({theme}) => ({
  display: "grid",
  gridGap: theme?.breakpoints?.md ? 16 : 20,
  gridTemplateColumns: theme?.breakpoints?.md ? "repeat(1, 1fr)" : "repeat(2, 1fr)",
  marginTop: theme?.breakpoints?.md ? 10 : 0,
}));

export const Container = styled.div(({theme}) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  aspectRatio: theme?.breakpoints?.md ? "359/250" : "646/313",
  transition: "box-shadow 0.5s ease",
  borderRadius: 16,
  ":hover": {
    boxShadow: "0px 0px 32px 0px rgba(0, 0, 0, 0.2)",
  },
}));

export const Image = styled.img(({theme}) => ({
  display: "flex",
  objectFit: "cover",
  width: "100%",
  height: "100%",
  borderRadius: 16,
  minHeight: theme?.breakpoints?.md ? 250 : 313,
}));

export const TextWrapper = styled.div(({theme}) => ({
  position: "absolute",
  display: "flex",
  maxWidth: theme?.breakpoints?.md ? "75%" : "100%",
  flexDirection: "column",
  padding: theme?.breakpoints?.md ? 16 : 40,
}));

export const Mask = styled.div(({theme}) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 54.15%)",
  width: "100%",
  height: theme?.breakpoints?.isMobile ? 150 : 228,
  borderRadius: 16,
}));
